import 'twin.macro';
import 'styled-components/macro';

export interface CourseMetaProps {
  /** Title above unit */
  label: string;
  /** Unit */
  number: number;
  /** Subtitle after unit */
  unit?: string;
}

export const CourseMeta = ({ label, unit, number, ...props }: CourseMetaProps) => (
  <div {...props} tw="flex flex-col items-center bg-gray-5 rounded-2xl px-1 pt-2 pb-5 leading-snug text-center">
    <div tw="text-lg/snug text-primary mb-4">{label}</div>
    <div tw="text-3xl/none font-semibold text-gray-95">{number}</div>
    {unit && <div tw="text-primary">{unit}</div>}
  </div>
);
